import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker'
import { Dayjs } from 'dayjs'

export type DatePickerPropsDayjs = DatePickerProps<Dayjs>

export default DatePicker
